import * as EnrollmentFileActions from 'Enrollment/ducks/enrollmentFileProcessing';
import * as qs from 'query-string';
import React, {useEffect} from 'react';
import {connect, useSelector} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import CardField from 'Shared/components/CardField';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import './EnrollmentFileDetails.sass';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {fromResult, toPage} from 'Core/models/Async';
import {useLocation} from 'react-router-dom';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';

type EnrollmentFileViewProps = {} & RouteComponentProps<{
  enrollmentFileId: string;
}> &
  ReturnType<typeof mapStateToProps> &
  typeof EnrollmentFileActions;

const getStatus = (warningSlaLimit: number, criticalSlaLimit: number, currentDays: number) =>
  currentDays >= criticalSlaLimit ? 'critical' : currentDays >= warningSlaLimit ? 'warning' : 'ok';

export const EnrollmentFileDetails = (props: EnrollmentFileViewProps) => {
  const {search} = useLocation();
  const enrollmentFileId = qs.parse(search).enrollmentFileId as string;
  const showEMW = useSelector((state: ReducerState) => state.enrollmentFileProcessing.showEMW);
  const {getEnrollmentFile} = props;
  useBreadcrumbs('File Details', EnrollmentRouteConstants.ENROLLMENT_FILE_DETAILS(enrollmentFileId!));

  useEffect(() => {
    getEnrollmentFile(enrollmentFileId, showEMW);
  }, [enrollmentFileId, showEMW, getEnrollmentFile]);

  return renderAsyncView(props.enrollmentFile, enrollmentFile => (
    <div className="enrollment-file-details">
      <h1 id="enrollment-file-details-title" className="enrollment-file-details__agency-name">{enrollmentFile.agencyName}</h1>
      <div className="enrollment-file-details__file-proccessing-tasks">
        <div className="enrollment-file-details__file-details">
          <CardField
            className="enrollment-file-details__details-field"
            name="Case Number"
            value={enrollmentFile.caseNumber}
          />
          <CardField
            className="enrollment-file-details__details-field"
            name="Case Status"
            value={enrollmentFile.caseStatus}
          />
          <CardField
            className="enrollment-file-details__details-field"
            name="Enrollment Period"
            value={enrollmentFile.enrollmentPeriodName}
          />
        </div>
        <PagedView
          pagedViewKey="enrollmentFileDetails"
          data={fromResult(toPage(enrollmentFile.tasks))}
          loadMore={() => {}}
        >
          {columnProps => (
            <>
              <Column {...columnProps} title="Process Name" default>
                {enrollmentFileTask => enrollmentFileTask.name}
              </Column>
              <Column {...columnProps} title="Task Type" default>
                {enrollmentFileTask => (enrollmentFileTask.isBusinessTask ? 'Business' : 'IT')}
              </Column>
              <Column {...columnProps} title="Is Validation" default>
                {enrollmentFileTask => (enrollmentFileTask.isValidation ? 'Yes' : 'No')}
              </Column>
              <Column {...columnProps} title="Actual" default>
                {enrollmentFileTask => enrollmentFileTask.actualDays}
              </Column>
              <Column {...columnProps} title="Ok SLA" default>
                {enrollmentFileTask => enrollmentFileTask.okSlaLimit}
              </Column>
              <Column {...columnProps} title="Warning SLA" default>
                {enrollmentFileTask => enrollmentFileTask.warningSlaLimit}
              </Column>
              <Column {...columnProps} title="Status" default>
                {enrollmentFileTask => (
                  <i
                    className={`enrollment-file-details__dot--${getStatus(
                      enrollmentFileTask.okSlaLimit!,
                      enrollmentFileTask.warningSlaLimit!,
                      enrollmentFileTask.actualDays!
                    )}`}
                  />
                )}
              </Column>
            </>
          )}
        </PagedView>
      </div>
    </div>
  ));
};

const mapStateToProps = (state: ReducerState) => ({
  enrollmentFile: state.enrollmentFileProcessing.enrollmentFile,
});

export default connect(mapStateToProps, {...EnrollmentFileActions})(withRouter(EnrollmentFileDetails));
